import styled from '@emotion/styled';

export const ShareButtons = styled.div`
  margin-bottom: 15px;
  padding: 10px 0;
  display: flex;
`;
